module.exports = __webpack_public_path__ + "img/34b1a90.jpg";